import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { RootState } from "@src/store/store";
import { pricingActions } from "@src/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;
interface IListingToUpdate {
	alterAmount: number;
	blackoutEnd: null;
	blackoutStart: null;
	endDateTime: Date | string;
	endPrice: number;
	listingIds: Array<number>;
	priceCycleMinutes: number;
	startDateTime: Date | string;
	startPrice: number;
}

export const { thunk: updateSchedulePrice, slice: updateSchedulePriceSlice } = getThunkAndSlice<
	IListingToUpdate,
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/ScheduleListingPricing",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const listingIds = new Set(params.listingIds);
		const inventoryAllState = rootState.pricing.eventInventoryAll.data;
		const newData = inventoryAllState.map((x) => {
			return listingIds.has(x.Listing_ID)
				? { ...x, FlashSaleEnabled: null, FlashSaleDiscount: null, Is_Scheduled_Pricing: true }
				: x;
		});

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((x) => {
				return listingIds.has(x.Listing_ID)
					? { ...x, FlashSaleEnabled: null, FlashSaleDiscount: null, Is_Scheduled_Pricing: true }
					: x;
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
